// gastos.repository.js

import { supabase } from '../../../infra_/supabase/supabaseClient.js'; 


export const guardarGasto = async (gasto) => {
  console.log("[Repo]:", gasto);

  const { data, error } = await supabase
    .from("gastos_tienda")
    .insert([gasto])
    .select(`
    id_gasto,
    fecha_creacion,
    item_valor,
    item_cantidad,
    metodo_pago,
    id_categoria,
    proveedor,
    detalle,
    estado
  `)
    .single();
 

  if (error) {
    console.error("Error al guardar gasto:", error.message);
    throw new Error("No se pudo registrar el gasto");
  }

  return {
  id: data.id_gasto,
  fecha: data.fecha_creacion,
  valor: data.item_valor,
  cantidad: data.item_cantidad,
  categoria: data.id_categoria,
  metodoPago: data.metodo_pago,
  proveedor: data.proveedor,
  detalle: data.detalle,
  estado: data.estado,
};
};


export const gastosRepository = {
  async listar(filtros = {}) {
    let query = supabase
      .from("gastos_tienda")
      .select("*")
      .order("id_gasto", { ascending: false })
      .limit(filtros.limit ?? 31); 
 
    if (filtros.estado) {
      query = query.eq("estado", filtros.estado);
    }

    const { data, error } = await query;
    if (error) throw error;

    return data;
  },
};